import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { HintTypeEnum } from 'projects/workspace/src/app/hrm/models/hints-list.model';
import {
  getBillTimeHints
} from 'projects/workspace/src/app/time-tracking/time-tracking-hints.config';
import { takeUntil } from 'rxjs/operators';
import {
  BaseMegaHintComponentDependences,
  BaseMegaHintsComponent
} from '../../../rnpl-common/components/base-mega-hints/base-mega-hints.component';

@Component({
  selector: 'rnpl-bill-time-hints',
  templateUrl: './bill-time-hints.component.html',
})
export class BillTimeHintsComponent extends BaseMegaHintsComponent implements OnInit, OnChanges {

  @Input() public hasServices: boolean;
  @Input() public screenName: string;

  constructor(
    public deps: BaseMegaHintComponentDependences
  ) {
    super(deps);
  }

  ngOnInit() {
    this.endFinishText = 'BUTTON.BILL_TIME';
    if (this.shepherdService.isActive) {
      this.shepherdService.cancel();
      this.shepherdService.complete();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.hasOwnProperty('hasServices')) {
      clearInterval(this.countdownTimer);
      if (this.shepherdService.isActive) {
        this.shepherdService.cancel();
        this.animationStateIsPaused$.next(false);
      }

      this.initHints();
    }
  }

  private initHints(): void {
    this.hintsList = [];
    this.notViewedHintsList = [];

    this.hrmService.getHintsByPage(this.screenName)
      .pipe(takeUntil(this._destroy))
      .subscribe(hints => {

        if (!!hints.data.hints && !!hints.data.hints.length) {
          this.hintListByName = getBillTimeHints(this.hasServices);

          this.hintsList = this.prepareHintsList(hints.data.hints)
            .filter(hint => hint.type !== HintTypeEnum.MEGA)
            .filter(hint => !!this.hintListByName[hint.name]);

          this.notViewedHintsList = this.prepareHintsList(hints.data.hints)
            .filter(hint => hint.type !== HintTypeEnum.MEGA)
            .filter(hint => !hint.viewed)
            .filter(hint => !!this.hintListByName[hint.name]);

          this.megaHintId = +hints.data.hints[0].id;

          if (!!this.notViewedHintsList && !!this.notViewedHintsList.length) {
            this.addHintsSteps(this.notViewedHintsList);
          }

          if (!!this.notViewedHintsList && !!this.notViewedHintsList.length && !this.shepherdService.isActive) {
            this.shepherdService.start();
          }
        }
      });
  }

}
